var map = {
	"./capterra-shortlist-badge": 31,
	"./capterra-shortlist-badge.png": 31,
	"./customers/craft-supply-house": 32,
	"./customers/craft-supply-house.jpg": 32,
	"./customers/hawkhouse": 33,
	"./customers/hawkhouse.jpg": 33,
	"./customers/sweet-backflip": 34,
	"./customers/sweet-backflip.jpg": 34,
	"./customers/theory-house": 35,
	"./customers/theory-house.jpg": 35,
	"./drawn-heart": 36,
	"./drawn-heart.svg": 36,
	"./external-services/amazon-logo": 37,
	"./external-services/amazon-logo.svg": 37,
	"./external-services/bandcamp-logo": 38,
	"./external-services/bandcamp-logo.svg": 38,
	"./external-services/bigcommerce-logo": 39,
	"./external-services/bigcommerce-logo.svg": 39,
	"./external-services/ebay-logo": 40,
	"./external-services/ebay-logo.svg": 40,
	"./external-services/etsy-logo": 41,
	"./external-services/etsy-logo.svg": 41,
	"./external-services/facebook-logo": 42,
	"./external-services/facebook-logo.svg": 42,
	"./external-services/faire-logo": 43,
	"./external-services/faire-logo.svg": 43,
	"./external-services/google-shopping-logo": 44,
	"./external-services/google-shopping-logo.svg": 44,
	"./external-services/quickbooks-online-logo": 45,
	"./external-services/quickbooks-online-logo.svg": 45,
	"./external-services/shopify-logo": 46,
	"./external-services/shopify-logo.svg": 46,
	"./external-services/square-logo": 47,
	"./external-services/square-logo.svg": 47,
	"./external-services/squarespace-logo": 48,
	"./external-services/squarespace-logo.svg": 48,
	"./external-services/tiktok-logo": 49,
	"./external-services/tiktok-logo.svg": 49,
	"./external-services/walmart-logo": 50,
	"./external-services/walmart-logo.svg": 50,
	"./external-services/wix-logo": 51,
	"./external-services/wix-logo.svg": 51,
	"./external-services/woocommerce-logo": 52,
	"./external-services/woocommerce-logo.svg": 52,
	"./external-services/xero-logo": 53,
	"./external-services/xero-logo.svg": 53,
	"./features/bundles-1100": 54,
	"./features/bundles-1100.png": 54,
	"./features/bundles-2200": 55,
	"./features/bundles-2200.png": 55,
	"./features/inventory-linking-1100": 56,
	"./features/inventory-linking-1100.png": 56,
	"./features/inventory-linking-2200": 57,
	"./features/inventory-linking-2200.png": 57,
	"./features/inventory-syncing-1600": 58,
	"./features/inventory-syncing-1600.png": 58,
	"./features/inventory-syncing-800": 59,
	"./features/inventory-syncing-800.png": 59,
	"./features/sales-channels-1100": 60,
	"./features/sales-channels-1100.png": 60,
	"./features/sales-channels-2200": 61,
	"./features/sales-channels-2200.png": 61,
	"./getapp-category-leaders-badge": 62,
	"./getapp-category-leaders-badge.png": 62,
	"./landing-mockup-1440": 63,
	"./landing-mockup-1440.png": 63,
	"./landing-mockup-900": 64,
	"./landing-mockup-900.png": 64,
	"./preview-open-graph": 65,
	"./preview-open-graph.png": 65,
	"./preview-twitter-card": 66,
	"./preview-twitter-card.png": 66,
	"./software-advice-frontrunners-badge": 67,
	"./software-advice-frontrunners-badge.png": 67,
	"./testimonials/shopify-app-store-write-a-review-button": 68,
	"./testimonials/shopify-app-store-write-a-review-button.png": 68,
	"./testimonials/square-app-marketplace-write-a-review-button": 69,
	"./testimonials/square-app-marketplace-write-a-review-button.png": 69,
	"./trunk-icon": 70,
	"./trunk-icon.svg": 70,
	"./trunk-logo": 11,
	"./trunk-logo.svg": 11
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 110;